// @ts-nocheck

export type RoomGetWithPlans = typeof RoomGetWithPlans[keyof typeof RoomGetWithPlans];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithPlans = {
  true: 'true',
  false: 'false',
} as const;
